import React, { useState, useEffect } from 'react'; // React import hozzáadva
import { Box, LinearProgress, Typography } from '@mui/material';

interface BlueScreenProps {
  duration?: number; // Másodpercben, alapértelmezett 60
}

const BlueScreenOfDeath = ({ duration = 60 }: BlueScreenProps) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const intervalTime = 1000; // Frissítés másodpercenként
    const increment = 100 / duration;
    
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + increment;
      });
    }, intervalTime);

    return () => clearInterval(interval);
  }, [duration]); // duration függőség hozzáadva

  return (
    <Box
      sx={{
        backgroundColor: '#0078d7',
        color: 'white',
        minHeight: '100vh',
        width: '100vw',
        fontFamily: 'Segoe UI, sans-serif',
        position: 'fixed',
        top: 0,
        left: 0,
        padding: 15
      }}
    >
      <Typography variant="h1" gutterBottom>:(</Typography>
      <Typography variant="h5" gutterBottom>
        Your PC ran into a problem and needs to restart. We're just collecting some error info, and then we'll restart for you.
      </Typography>
      
      <Typography variant="body1" sx={{ mt: 4 }}>
        {`${Math.round(progress)}% complete`}
        <br />
        <br />
        For more information about this issue and possible fixes, visit:
        <br />
        https://www.windows.com/stopcode
      </Typography>

      <Box sx={{ 
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
      }}>
        <LinearProgress 
          variant="determinate" 
          value={progress}
          sx={{
            height: 8,
            backgroundColor: 'white',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#0078d7'
            }
          }}
        />
      </Box>
    </Box>
  );
};

export default BlueScreenOfDeath;